import { lazy } from 'react'

import AppRouteInterface from 'src/types/AppRouteInterface'
import { PRODUCT_PATHS, SubProduct } from 'src/utils/product'

const streamRoutes: ReadonlyArray<AppRouteInterface> = [
  {
    path: PRODUCT_PATHS[SubProduct.StreamingAnalytics],
    component: lazy(
      () =>
        /* webpackMode: "lazy", webpackChunkName: "stream__stream_dashboard__page" */
        import('src/components/ui/pages/products/Stream/StreamDashboardPage'),
    ),
  },
]

export default streamRoutes
